// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SlashIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13">
            <path
                fill="currentColor"
                d="M0.749419582,12.0007469 C0.62344302,12.0007469 0.495357168,11.9688952 0.378169668,11.9018643 C0.0186385041,11.6964113 -0.106752264,11.2383487 0.0990289574,10.8785829 L6.09902896,0.378582926 C6.30410708,0.0185832689 6.76184143,-0.107042103 7.12231029,0.0994422147 C7.48184146,0.304895134 7.60723223,0.762957782 7.401451,1.12272355 L1.401451,11.6227236 C1.26293529,11.8648097 1.01004447,12.0007469 0.749419582,12.0007469 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(SlashIcon);
